import {Injectable} from '@angular/core'
import {HttpClient, HttpParams} from '@angular/common/http'
import {catchError, map, Observable, throwError} from 'rxjs'
import {Alert, AlertSubscriber} from '@app/core/services/alert/alert.interface'
import {GetRegistrationsRequest} from '@app/core/services/contract/contract.service'

@Injectable()
export class AlertService {
  constructor(private http: HttpClient) {}

  notificationGroupsURL = 'api://NotificationGroups'

  public getAlerts(request: GetRegistrationsRequest): Observable<Alert[]> {
    let params: HttpParams = new HttpParams()
    if (request.sort) {
      params = params
        .set('sort', request.sort)
        .set('asc', !request.asc ? 'false' : 'true')
    }
    if (request.offset) {
      params = params.set('offset', request.offset.toString())
    }
    return this.http.get<any>(this.notificationGroupsURL, {params: params})
  }

  public getAlert(id: number): Observable<any> {
    const url = `${this.notificationGroupsURL}/${id}`
    return this.http.get<Alert>(url)
  }

  public createAlert(alert: Alert): Observable<Alert> {
    return this.http.post<Alert>(this.notificationGroupsURL, alert)
  }

  public updateAlert(id: number, alert: Alert): Observable<Alert> {
    return this.editAlert(id, alert).pipe(
      map((alertResult) => alertResult), // just return the main alert response
      catchError((error) => {
        console.error('Update failed:', error)
        return throwError(
          () => new Error('Failed to update alert, domains, or subscribers'),
        )
      }),
    )
  }

  private editAlert(id: number, alert: Alert): Observable<Alert> {
    const url = `${this.notificationGroupsURL}/${id}`
    return this.http.post<Alert>(url, alert)
  }

  private editDomains(id: number, domains: string[]): Observable<Alert> {
    const url = `${this.notificationGroupsURL}/${id}/Domains`
    return this.http.post<Alert>(url, domains)
  }

  private editSubscribers(
    id: number,
    subscribers: AlertSubscriber[],
  ): Observable<Alert> {
    const url = `${this.notificationGroupsURL}/${id}/Subscribers`
    const request = subscribers.map((subscriber) => ({
      subscriberId: subscriber.id,
      name: subscriber.name,
      email: subscriber.email,
    }))
    return this.http.post<Alert>(url, request)
  }

  public deleteAlert(id: number): Observable<void> {
    const url = `${this.notificationGroupsURL}/${id}`
    return this.http.delete<void>(url)
  }
}
